exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-template-container[data-v-78133281]{padding:16px}.menu-template-container .el-tabs .el-tabs__header[data-v-78133281]{margin-bottom:16px}", ""]);

// exports
